export default __webpack_public_path__ + "static/media/157467.a5dae23b.jpg";